import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export enum WIDGET_TYPES {
    SUPPORT = 'support',
    SUPPORT_AI = 'support-ai',
}

export const updateWidget = async (domain: string, widget: WIDGET_TYPES, meta: string, isActive: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `widget/update/${widget}`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: { meta, isActive },
        isEncrypted: true,
    });
}
